import { createTheme } from "@mui/material";
import {
  indigo,
  teal,
  grey,
  blue,
  green,
  orange,
  purple,
  lightBlue,
  lightGreen,
} from "@mui/material/colors";

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "1rem",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: "22px",
          "@media (min-width: 600px)": {
            minHeight: "20px",
          },
        },
      },
    },
  },
  palette: {
    nav: {
      main: "#43215d",
    },
    item: {
      selected: indigo[100],
      notSelected: grey[50],
    },
    background: {
      main: grey[200],
      focus: blue[100],
    },
    primary: {
      main: indigo[300],
    },
    secondary: {
      main: green[600],
    },
    sd36: {
      orange: orange[600],
      purple: purple[900],
      green: lightGreen[700],
      blue: lightBlue[300],
    },
  },
  typography: {
    h1: {
      fontSize: "2rem",
    },
    h2: {
      fontSize: "1.75rem",
    },
    h3: {
      fontSize: "1.5rem",
    },
    h4: {
      fontSize: "1.35rem",
    },
    h5: {
      fontSize: "1.25rem",
    },
    h6: {
      fontSize: "1.1rem",
      fontWeight: "bold",
    },
    body1: {
      lineHeight: "1.2",
    },
  },
});

export default theme;
